export { SearchService } from './lib/services/search.service';
export * from './lib/shared-search-lib.module';
